<template>
    <div :id="id" :class="classObject">
        <a :href="link" :class="contentClass" title="Visualizza" v-if="!!link">
            <div :class="iconClass" v-if="!!icon">
                <font-awesome-icon :icon="icon"></font-awesome-icon>
            </div>
            <div :class="textClass" v-if="showText">{{ text }}</div>
            <div :class="titleClass" v-if="!!title">{{ title }}</div>
        </a>

        <div :class="contentClass" v-else>
            <div :class="iconClass" v-if="!!icon">
                <font-awesome-icon :icon="icon"></font-awesome-icon>
            </div>
            <div :class="textClass" v-if="showText">{{ text }}</div>
            <div :class="titleClass" v-if="!!title">{{ title }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
            required: false
        },
        color: {
            type: String,
            default: null,
            required: false
        },
        title: {
            type: String,
            default: null,
            required: false
        },
        icon: {
            type: Array,
            default: null,
            required: false
        },
        text: {
            type: String,
            default: null,
            required: false
        },
        small: {
            type: Boolean,
            default: false,
            required: false
        },
        smallText: {
            type: Boolean,
            default: false,
            required: false
        },
        iconBig: {
            type: Boolean,
            default: false,
            required: false
        },
        link: {
            type: String,
            default: null,
            required: false
        }
    },
    computed: {
        classObject: function() {
            return {
                widget: true,
                ["widget-" + this.color]: !!this.color,
                small: !!this.small,
                "has-link": !!this.link
            };
        },
        contentClass: function() {
            return "widget-content";
        },
        titleClass: function() {
            return "widget-title headline-font";
        },
        iconClass: function() {
            return {
                "widget-icon": true,
                big: !!this.iconBig
            };
        },
        textClass: function() {
            return {
                "widget-text": true,
                "headline-font": true,
                small: !!this.small,
                "small-text": !!this.smallText
            };
        },
        showText: function() {
            return !!this.text || this.text == 0;
        }
    }
};
</script>
